import { useIntl } from 'react-intl';

import { useAppSelector } from '@verantos-dev/app-state-base';
import { selectModal, useCohortEditable } from '@verantos-dev/app-state-cohort-builder';
import { selectCohortDefinitionError } from '@verantos-dev/app-state-cohort-definition';
import { useCohortBuilderData } from '@verantos-dev/data-access-cohorts';
import { CohortStatusLegacy } from '@verantos-dev/types-cohorts';

import { CohortBuilderEmptyStateCardProps } from '../../../../../components/CohortBuilderEmptyStateCard/CohortBuilderEmptyStateCard';
import { CohortSectionHeaderProps } from '../../../../../components/CohortSection/CohortSectionHeader/CohortSectionHeader';
import { useCohortBuilderModalContext } from '../../../../../contexts/CohortBuilderModalContext';

export const useDerivedEventsCohortSection = (
  onAddDerivedEventClick: () => void,
  isAddDerivedEventDisabled: boolean,
  disabledAddDerivedEventTooltipText?: string
) => {
  const intl = useIntl();
  const { data: cohortData } = useCohortBuilderData();
  const isProcessing =
    !!cohortData?.data.latestStatus &&
    [CohortStatusLegacy.PROCESSING, CohortStatusLegacy.FINAL].includes(
      cohortData?.data.latestStatus
    );
  const { isEditable, isCohortProfileLoading, isCohortVersionLoading } = useCohortEditable();
  const viewMode = !isEditable || isProcessing;

  const isError = !!useAppSelector(selectCohortDefinitionError);
  const modal = useAppSelector(selectModal);
  const { activeDialog } = useCohortBuilderModalContext();

  const headerProps: CohortSectionHeaderProps = {
    title: intl.formatMessage({
      id: 'projects.cohortBuilder.derivedEventsSection.title',
    }),
    action: !viewMode
      ? {
          label: intl.formatMessage({
            id: 'projects.cohortBuilder.derivedEventsSection.buttonLabel',
          }),
          labelIcon: 'add',
          onClick: onAddDerivedEventClick,
          tooltipText: disabledAddDerivedEventTooltipText,
          disabled:
            isAddDerivedEventDisabled ||
            viewMode ||
            isCohortProfileLoading ||
            isCohortVersionLoading ||
            isError ||
            modal !== undefined ||
            activeDialog !== null,
        }
      : undefined,
  };

  const emptyStateProps: CohortBuilderEmptyStateCardProps = {
    id: 'derivedEvents-empty-state',
    mainMessage: intl.formatMessage({
      id: 'projects.cohortBuilder.derivedEventsSection.noDerivedEventsMainMsg',
    }),
    subMessage: intl.formatMessage({
      id: 'projects.cohortBuilder.derivedEventsSection.noDerivedEventsSubMsg',
    }),
  };

  return {
    headerProps,
    emptyStateProps,
  };
};
